(() => {
  const tryPlay = (video) => {
    if (!video) return Promise.resolve();
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.playsInline = true;
    video.removeAttribute('poster');
    video.removeAttribute('src');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    const result = video.play();
    return result && typeof result.then === 'function'
      ? result.catch(() => {})
      : Promise.resolve();
  };

  const initHero = (hero) => {
    if (!hero || hero.dataset.tkHeroVideoInit === '1') return;
    hero.dataset.tkHeroVideoInit = '1';

    const video = hero.querySelector('video[data-tk-hero-video], .tk-hero__video');
    if (!video) return;

    hero.querySelectorAll('.tk-hero__stage img').forEach((img) => img.remove());

    const kick = () => tryPlay(video);
    ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach((evt) => {
      video.addEventListener(evt, kick);
    });
    kick();

    ['touchstart', 'click', 'scroll'].forEach((evt) => {
      document.addEventListener(evt, kick, { once: true, passive: true });
    });

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if ((!video.paused && video.currentTime > 0.2) || tries > 20) {
        window.clearInterval(timer);
        return;
      }
      kick();
    }, 400);
  };

  const boot = () => {
    document.querySelectorAll('[data-tk-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!root) return;
    root.querySelectorAll('[data-tk-hero]').forEach((hero) => {
      delete hero.dataset.tkHeroVideoInit;
      initHero(hero);
    });
  });
})();
